import React from "react";
import { ProfileProvider } from "../../context/ProfileContext";
import { Profile } from "./index";

export const ProfileWrapper = () => {
  return (
    <ProfileProvider>
      <Profile />
    </ProfileProvider>
  );
};

export default ProfileWrapper;
